import { FC } from 'react';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { Link, Typography } from 'melp-design/components';
import { ROUTES } from 'config';
import { useTranslation } from 'react-i18next';

interface Props {
  items: Array<{ label: string; url?: string }>;
}

export const Breadcrumbs: FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      <Link to={ROUTES.root.index} label={t('global.home.label')} />

      {items.map((item, i) =>
        item.url ? (
          <Link to={item.url} label={item.label} key={i} />
        ) : (
          <Typography variant="h3" color="textPrimary" key={i}>
            {item.label}
          </Typography>
        ),
      )}
    </MuiBreadcrumbs>
  );
};
